<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Bus Tracking</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Child</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="child"
              :items="child_list"
              item-text="learner"
              item-value="id"
              label="Child"
              outlined
              persistent-hint
              hint="Please Select Child"
            />
          </v-col>

          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
          <v-col
            col="12"
            sm="2"
            md="2"
            class="pt-6 mt-6"
            v-if="this.ay && this.child"
          >
            <v-btn color="warning" @click="fetchData()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <!-- Child Details Card -->
      <v-card v-if="show_child_details_card" class="box elevation-5 pa-4" color="#f0f4f8">
        <v-toolbar flat dense class="toolbar" color="#0F2027" dark>
          <v-toolbar-title>Child Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row justify="center" dense class="pt-4">
          <!-- PRN -->
          <v-col cols="12" sm="1" class="text-center">
            <p><v-icon color="primary" class="mr-1">mdi-card-account-details</v-icon><b>PRN</b></p>
            <strong>{{ child_details.registration_number }}</strong>
          </v-col>

          <!-- Student Name -->
          <v-col cols="12" sm="2" class="text-center">
            <p><v-icon color="primary" class="mr-1">mdi-account</v-icon><b>Student Name</b></p>
            <strong>{{ child_details.learner }}</strong>
          </v-col>

          <!-- Standard -->
          <v-col cols="12" sm="1" class="text-center">
            <p><v-icon color="primary" class="mr-1">mdi-school</v-icon><b>Standard</b></p>
            <strong>{{ child_details.standard }}</strong>
          </v-col>

          <!-- Division -->
          <v-col cols="12" sm="1" class="text-center">
            <p><v-icon color="primary" class="mr-1">mdi-domain</v-icon><b>Division</b></p>
            <strong>{{ child_details.learnerDivision }}</strong>
          </v-col>

          <!-- Roll No -->
          <!-- <v-col cols="12" sm="1">
            <p><v-icon color="primary" left>mdi-numeric"></v-icon><b>Roll No</b></p>
            <strong>{{ child_details.roll_no }}</strong>
          </v-col> -->

          <!-- Bus Number -->
          <v-col cols="12" sm="2" class="text-center">
            <p><v-icon color="primary" class="mr-1">mdi-bus-school</v-icon><b>Bus Number</b></p>
            <strong v-if="child_details.bus_number != '--'">{{ child_details.bus_number }}</strong>
            <strong v-else>-</strong>
          </v-col>

          <!-- Bus Tracking -->
          <v-col cols="12" sm="2" class="text-center">
            <p><v-icon color="primary">mdi-map-marker</v-icon><b>Bus Tracking</b></p>
            <strong v-if="child_details.bus_tracking_url !== '--'">
              <a :href="child_details.bus_tracking_url" target="_blank">
                <v-icon left>mdi-bus</v-icon>
                <!-- <v-icon>mdi-map-marker</v-icon> -->

              </a>
            </strong>
            <strong v-else>-</strong>
          </v-col>
        </v-row>
      </v-card>

     <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Bus Tracking utorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/FVYR0anwu9A?si=4nUliAfvcnQh5nPV"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      videoDialog:false,
      color: "",
      snackbar: false,
      overlay: false,
      title:"",
      description:"",
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
      ay_list:[],ay:"",child_list:[],child:"",show_child_details_card:false,
       child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      pickup_time: "",
      drop_time: "",
      academicYear: "",
      contact: "",
      resedential_address: "",
      learnerDivision: "",
      roll_no: "",
      bus_number:"",
      bus_name:"",
      bus_tracking_url:""
    },
  }),
   methods: {
      fetchData() {
      const data = {
        ay: this.ay,
        child: this.child,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getChildAcademicDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.child_details.registration_number =
              res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            // this.child_details.pickup_time = res.data.pickup_time;
            this.child_details.learnerDivision = res.data.learnerDivision;
            this.child_details.roll_no = res.data.roll_no;
            // this.child_details.drop_time = res.data.drop_time;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.contact = res.data.contact;
            this.child_details.bus_number = res.data.bus_number;
            this.child_details.bus_name = res.data.bus_name;
            this.child_details.bus_tracking_url = res.data.bus_tracking_url;
            this.show_child_details_card = true;
          }else if(res.data.flag == "No"){
            this.showSnackbar("red", res.data.snackbar);
          } 
          else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
     onLoad() {
      axios
        .post("ParentTransport/applyTransportFacility")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.child_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    async viewStudentMedicalForm(item) {
      alert(item.id);
      localStorage.setItem("medical_form_no", item.id);
      try {
          const res = await axios.post("/HealthCard/generateReceipt", data);
          if (res.data.flag == "YES") {
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>